module.exports = __webpack_public_path__ + "static/netx-logo-569723f5d9d574d78ebe5f584b44e439.png";